import baseUrl from "../config/baseUrl";

const deleteRole = async ({ token, id }) => {

  try {
    const response = await fetch(
      `${baseUrl}/api/delete-role?role_id=${id}`,
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteRole;
